import { ReactNode } from "react";
import { Link } from "react-router-dom";

import LinkIcon2 from "@/assets/icons/LinkIcon2";

type Props = {
  children: ReactNode;
};

export default function NavCard({ children }: Props) {
  return (
    <div className="fixed left-0 right-0 top-[85px] z-[51] flex justify-center px-4 pointer-events-none">
      <div className="pointer-events-auto w-full max-w-[1350px]">
        <div className="nav-dropdown-enter p-7 bg-background/80 backdrop-blur-[5px] rounded-lg outline outline-1 outline-offset-[-1px] outline-white/30">
          {children}
        </div>
      </div>
    </div>
  );
}



type ItemType = {
  label: string;
  link: string;
};

type ListItemType = {
  title: string;
  link?: string;
  list: ItemType[];
  list2?: ItemType[];
};

const ListItem = ({ title, list, link, list2 }: ListItemType) => (
  <div>
    <h5 className="text-xl font-medium flex justify-between items-center text-title-primary pb-3 mb-3 border-b border-[#5E718D]">
      <span>{title}</span>{" "}
      {link && (
        <Link className="text-secondary cursor-pointer" to={link}>
          <LinkIcon2 />
        </Link>
      )}
    </h5>
    <div className="grid grid-cols-2 gap-6">
      <ul>
        <Item list={list} />
      </ul>

      {list2?.length ? (
        <ul>
          <Item list={list2} />
        </ul>
      ) : null}
    </div>
  </div>
);

const Item = ({ list }: { list: ItemType[] }) => {
  return list.map((el) => {
    const isInternal = el.link.startsWith("/");

    return (
      <li key={el.label} className="text-base font-normal mb-2 last:mb-0">
        {isInternal ? (
          <Link
            className="text-sub-title hover:text-secondary transition-colors text-nowrap"
            to={el.link}
          >
            {el.label}
          </Link>
        ) : (
          <a
            className="text-sub-title hover:text-secondary transition-colors text-nowrap"
            href={el.link}
            rel="noopener noreferrer"
            target="_blank"
          >
            {el.label}
          </a>
        )}
      </li>
    );
  });
};

NavCard.ListItem = ListItem;
